import { render, staticRenderFns } from "./CallTelephonyModal.vue?vue&type=template&id=285842bb&"
import script from "./CallTelephonyModal.vue?vue&type=script&lang=js&"
export * from "./CallTelephonyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports